import { render, staticRenderFns } from "./ZubieRoot.vue?vue&type=template&id=87cff7de&"
import script from "./ZubieRoot.vue?vue&type=script&lang=js&"
export * from "./ZubieRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports